import type { ReactNode } from "react";

import { Alert, Button, Card, Skeleton } from "../ds";

/* Lo que se ve mientras llegan los datos de una pantalla, o si fallaron. */
export function Carga({ error, onReintentar, children, filas = 3 }: { error: string | null; onReintentar: () => void; children?: ReactNode; filas?: number }) {
  if (error) {
    return (
      <Alert tone="danger" title="No se pudieron cargar los datos">
        {error}{" "}
        <Button size="sm" variant="ghost" icon="refresh-cw" onClick={onReintentar}>
          Reintentar
        </Button>
      </Alert>
    );
  }
  return (
    children ?? (
      <Card padding="lg" aria-busy="true" aria-label="Cargando">
        <Skeleton lines={filas} />
      </Card>
    )
  );
}
